/**
 * Robust clipboard copy that works inside the Emergent preview iframe.
 * Tries the modern navigator.clipboard API first, falls back to a hidden
 * textarea + document.execCommand('copy') which works even when the iframe
 * sandbox does NOT have the `allow-clipboard-write` permission.
 *
 * Returns true on success, false otherwise — caller decides whether to toast.
 */
export async function copyToClipboard(text) {
  if (text == null) return false;
  const value = String(text);

  // Strategy 1: modern Clipboard API (preferred, async)
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch { /* fall through to legacy strategy */ }

  // Strategy 2: hidden textarea + execCommand('copy') — works in legacy
  // browsers AND in sandboxed iframes where the Clipboard API is blocked.
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.opacity = "0";
    ta.style.pointerEvents = "none";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
